import { render, staticRenderFns } from "./policyInquiry.vue?vue&type=template&id=e7ee5f66&scoped=true"
import script from "./policyInquiry.vue?vue&type=script&lang=js"
export * from "./policyInquiry.vue?vue&type=script&lang=js"
import style0 from "./policyInquiry.vue?vue&type=style&index=0&id=e7ee5f66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7ee5f66",
  null
  
)

export default component.exports